// extracted by mini-css-extract-plugin
export default {"tableHeader":"TableHeader_tableHeader__eEtlg","expandColumn":"TableHeader_expandColumn__bBYY2","headerCell":"TableHeader_headerCell__ODhYb"};